import dynamic from 'next/dynamic'
import PageHead from '../../../components/PageHead'
import { t } from '../../../utils'
import DevicesLimitModal from '../../../components/modals/DevicesLimitModal'
import StoreCredit from './StoreCredit'
import isDevUser from '../../../utils/isDevUser'
import { useAuth } from '../../../utils/auth'
import FreeTrialBanner from '../../../components/FreeTrialBanner'
import StoreHeader from './StoreHeader'

const StoreFooter = dynamic(() => import('./../../../components/Footer'))

interface LayoutProps {
  pageTitle?: string
  pageDescription?: string
  children?: React.ReactNode
}

const StoreLayout: React.FC<LayoutProps> = ({
  children,
  pageTitle = t('WorshipOnline - Store'),
  pageDescription = t(
    'From high quality keyboard patches/sounds, to all the individual vocal/multi tracks in different keys, get the tools you need to help you practice and play! '
  )
}) => {
  const { currentUser } = useAuth()
  return (
    <>
      <DevicesLimitModal />
      <FreeTrialBanner />
      <PageHead title={pageTitle} description={pageDescription} />
      <div className="header-container">
        <StoreHeader />
      </div>
      {children}
      <StoreFooter />
      {isDevUser(currentUser) && currentUser?.labSubscriptionActive && (
        <StoreCredit />
      )}
    </>
  )
}

export default StoreLayout
